'use strict';

const containerTemplate = '<sa-location-search-predictions></sa-location-search-predictions>';
const formatValue = function (value) {
  var viewValue;

  if (angular.isString(value)) {
    viewValue = value;
  } else if (angular.isObject(value)) {
    viewValue = value.fullName || value.name;
  }

  return viewValue;
};
const saLocationSearchInput = [
  '$document',
  '$timeout',
  '$compile',
  'keyCodes',
  'autocompleteService',

  function ($document, $timeout, $compile, keyCodes, autocompleteService) {
    return {
      restrict: 'A',
      require: ['ngModel', '?^saLocationSearchForm'],
      scope: {
        model: '=ngModel',
        locationType: '@'
      },
      link: function ($scope, $element, $attrs, ctrls) {
        var ngModelCtrl = ctrls[0];
        var saLocationSearchFormCtrl = ctrls[1];
        var documentEl = angular.element(document);
        var bodyEl = angular.element(document.body);
        var type;
        if ($scope.locationType !== 'none') {
          type = $scope.locationType || 'regions';
        }
        var predictionContainer;
        var shouldCancelBlur;
        var query;

        $scope.element = $element;
        $scope.selectedPrediction = -1;

        // Load google maps js and initialize directive when done

        initPredictionsContainer();
        addEventListeners();

        /**
         * Creates container for predictions
         */
        function initPredictionsContainer() {
          var container = angular.element(containerTemplate);

          container.attr({
            predictions: 'predictions',
            input: 'element',
            'selected-prediction': 'selectedPrediction'
          });

          predictionContainer = $compile(container)($scope);
          bodyEl.append(predictionContainer);
        }

        /**
         * Adds event listeners to input field and document
         */
        function addEventListeners() {
          $element.on('keyup', keyupHandler);
          $element.on('keydown', keydownHandler);
          $element.on('keypress', keypressHandler);

          $timeout(function () {
            predictionContainer.on('mousedown', function () {
              shouldCancelBlur = true;
            });

            predictionContainer[0].addEventListener('click', function () {
              clearPredictions();

              saLocationSearchFormCtrl && saLocationSearchFormCtrl.submitForm();
            }, true);
          });

          $element.on('blur', function () {
            if (shouldCancelBlur) {
              $element[0].focus();
              shouldCancelBlur = false;
            } else {
              if ($scope.predictions) {
                $scope.$apply(() => {
                  $scope.selectedPrediction = ($scope.selectedPrediction > -1) ? $scope.selectedPrediction : 0;
                  setValue();
                });
              }

              clearPredictions();
            }
          });
        }

        /**
         * Handles keydown event
         * @param event
         */
        function keydownHandler(event) {
          switch (event.which) {
          case keyCodes.DOWN:
          case keyCodes.UP:
            event.preventDefault();
            break;

          case keyCodes.ENTER:
            if (document.activeElement === $element[0] && $scope.predictions && $scope.predictions.length) {
              $scope.selectedPrediction = ($scope.selectedPrediction > -1) ? $scope.selectedPrediction : 0;
              setValue();
              clearPredictions();

              if (!saLocationSearchFormCtrl) {
                event.preventDefault();

                return false;
              }
            }
            break;
          }
        }

        /**
         * Handles keydown event
         * @param event
         */
        function keypressHandler(event) {
          switch (event.which) {
          case keyCodes.ENTER:
            if (document.activeElement === $element[0] && $scope.predictions && $scope.predictions.length && !saLocationSearchFormCtrl) {
              event.preventDefault();

              return false;
            }
            break;

          default:
            break;
          }
        }

        /**
         * Handles keyup event
         * @param event
         */
        function keyupHandler(event) {
          $scope.$apply(function () {
            switch (event.which) {
            case keyCodes.DOWN:
              if ($scope.predictions) {
                $scope.selectedPrediction = Math.min($scope.selectedPrediction + 1, $scope.predictions.length - 1);
              }
              break;

            case keyCodes.UP:
              if ($scope.predictions) {
                $scope.selectedPrediction = Math.max($scope.selectedPrediction - 1, 0);
              }
              break;

            case keyCodes.ESC:
              clearPredictions();
              break;

            case keyCodes.ENTER:
              break;

            default:
              fetchPredictions($element.val());
              break;
            }
          });
        }

        /**
         * Fetch predictions
         * @param {String} newQuery
         */
        function fetchPredictions(newQuery) {
          var previousQuery = query;
          var options;

          query = newQuery;

          if (newQuery && newQuery !== previousQuery && $scope.selectedPrediction === -1) {
            options = {
              input: newQuery,
            };
            if ($scope.locationType !== 'none' && $scope.locationType !== 'filtered') {
              options.types = ['(' + type + ')'];
            }

            // Callback is called immediatelly if status is OVER_QUERY_LIMIT
            autocompleteService.getPlacePredictions(newQuery).then(
              function (predictions) {
                clearPredictions();
                $scope.predictions = predictions.data;
              }
            );
          } else if (!newQuery) {
            clearPredictions();
          }
        }

        // Setup ngModelCtrl
        ngModelCtrl.$formatters.push(formatValue);
        ngModelCtrl.$render = function () {
          $element.val(formatValue(ngModelCtrl.$viewValue || ''));
        };
        ngModelCtrl.$parsers.push(function (input) {
          if (angular.isString(input) && ngModelCtrl.$modelValue && ngModelCtrl.$modelValue.name === input) {
            input = ngModelCtrl.$modelValue;
          }

          return input;
        });

        /**
         * Removes document event listeners
         */
        function removeEventListeners() {
          documentEl.off('keyup', keyupHandler);
          documentEl.off('keydown', keydownHandler);
        }

        /**
         * Sets ngModel value
         */
        function setValue() {
          var prediction;

          if ($scope.predictions) {
            prediction = $scope.predictions[($scope.selectedPrediction > -1) ? $scope.selectedPrediction : 0];

            if (prediction) {
              ngModelCtrl.$setViewValue({
                placeId: prediction['place_id'],
                name: prediction.description
              });
              ngModelCtrl.$commitViewValue();
              ngModelCtrl.$render();
            }

          }
        }

        /**
         * Removes predictions and resets selected prediction index
         */
        function clearPredictions() {
          delete $scope.predictions;
          $scope.selectedPrediction = -1;
        }

        /**
         * Cleans up after element is destroyed
         */
        $element.on('$destroy', function () {
          if (predictionContainer) {
            predictionContainer.remove();
          }

          removeEventListeners();
        });

        $scope.$watch('selectedPrediction', function (selectedPrediction, previousValue) {
          if (angular.isNumber(selectedPrediction) && selectedPrediction > -1 && selectedPrediction !== previousValue) {
            setValue();
          }
        });
      }
    };
  }
];

export default saLocationSearchInput;



// WEBPACK FOOTER //
// ./app/src/common/location_search/location_search_input.js